import React, { useState } from 'react';
import { Card } from '../shadcn-ui/card';
import { ChevronDown, ChevronUp, Pencil } from 'lucide-react';
import { format } from 'date-fns';
import { formatReadableDate } from '@/pages/storage-screens/StorageLotDetailPage';
import UpdateConsumptionDrawer from './UpdateConsumptionDrawer';

const formatDate = date => {
  return format(date, 'dd-MM-yyyy');
};

const ConsumptionCard = ({ idx, consumption, fetchStorageConsumptions, storageDetailLots, fetchStorageDetailLots }) => {
  const [open, setOpen] = useState(false);
  
  return (
    <Card className="flex justify-between p-3">
      <div className="flex flex-1 flex-col">
        <div className="font-medium">
          {idx + 1}. {formatDate(consumption?.date_of_consumption)}
        </div>
        {!open ? (
          <div className="text-sm">
            <div className="flex items-center gap-1 text-secondary-foreground">
              <div className="inline-block font-medium">Lot:</div> {consumption?.storage_label || 'N/A'}
              <div className="inline-block font-medium">• Weight:</div> {consumption?.weight || 'N/A'} kg
            </div>
          </div>
        ) : (
          <div className="mt-1 text-sm text-secondary-foreground">
            <div className="flex items-center gap-1">
              <div className="font-medium">Date of Consumption: </div>
              {formatReadableDate(consumption?.date_of_consumption)}
            </div>
            <div className="flex items-center gap-1">
              <div className="font-medium">Lot: </div>
              {consumption?.storage_label || 'N/A'}
            </div>
            <div className="flex items-center gap-1">
              <div className="font-medium">Weight: </div>
              {consumption?.weight || 'N/A'} kg
            </div>
            <div className="flex gap-1">
              <div className="font-medium">Reason: </div>
              {consumption?.reason || 'N/A'}
            </div>
          </div>
        )}
      </div>
      <div className="mt-2 flex items-start justify-start gap-2">
        {/* <button className="mr-1 flex-shrink-0"> */}
        {/* <button className="mr-1 flex-shrink-0" onClick={handlePencilClick}> */}
        {/* <Pencil className="h-5 w-5" /> */}
        <UpdateConsumptionDrawer
          consumption={consumption}
          fetchStorageConsumptions={fetchStorageConsumptions}
          storageDetailLots={storageDetailLots}
          fetchStorageDetailLots={fetchStorageDetailLots}
        />
        {/* </button> */}
        <button className="mr-1 flex-shrink-0" onClick={() => setOpen(!open)}>
          {open ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
        </button>
      </div>
    </Card>
  );
};

export default ConsumptionCard;
